<template>
  <Head :title="session.title" />

  <div class="layout-game" :class="{ paused: isPaused }">
    <div class="backdrop"></div>

    <div class="container-wrapper">
      <div class="container" :class="`role-${auth.role?.value}`">
        <header class="main">
          <div class="logo">
            <h1>
              <Link href="/game">
                <span>{{ appTitle }}</span>
              </Link>
            </h1>
          </div>

          <div class="navigation">
            <nav>
              <ul>
                <li v-for="item in navigation" :key="`nav-${item.href}`">
                  <span v-if="item.disabled">
                    {{ item.label }}
                  </span>
                  <Link v-else :href="item.href" :class="{ active: item.isActive }">
                    {{ item.label }}
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          <div class="status">
            <HeaderRound />
            <HeaderAuth />
          </div>
        </header>

        <div class="main-wrapper">
          <template v-if="isPaused && !isActiveDuringBreak && !isFacilitator">
            <div class="pause-message">
              <p class="label">{{ $t('paused') }}</p>
              <PauseMessage />
            </div>
          </template>

          <slot v-else />
        </div>
      </div>
    </div>
  </div>

  <YearReport />
  <Toaster :expand="true" />
</template>
<script setup lang="ts">
import { Head, Link, usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import { Toaster } from 'vue-sonner'

import PauseMessage from '/@front:components/PauseMessage.vue'
import YearReport from '/@front:components/YearReport.vue'
import { useServerSentEvents } from '/@front:composables/server-sent-events'
import { setThemeColor } from '/@front:composables/useThemeColor'
import type { PageProps } from '/@front:types/shared'

import HeaderAuth from './partials/HeaderAuth.vue'
import HeaderRound from './partials/HeaderRound.vue'

useServerSentEvents()
setThemeColor('#3e2723')

const page = usePage<PageProps>()
const appProps = computed(() => page.props.app)
const auth = computed(() => page.props.app.auth)
const appTitle = computed(() => appProps.value.title)
const navigation = computed(() => appProps.value.navigation || [])
const session = computed(() => page.props.session)

const isPaused = computed(() => session.value.roundStatus.value === 'paused')
const isFacilitator = computed(() => auth.value.type === 'facilitator')
const isActiveDuringBreak = computed(() => auth.value.activeDuringBreak)
</script>

<style scoped>
.pause-message {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  gap: 0.25em;
  text-align: center;

  & .label {
    font-weight: 550;
    text-transform: uppercase;
  }

  & .message {
    color: var(--gray-500);
  }
}
</style>
